import { render, staticRenderFns } from "./PDFPaginator.vue?vue&type=template&id=3c8d5ee2"
import script from "./PDFPaginator.vue?vue&type=script&lang=ts"
export * from "./PDFPaginator.vue?vue&type=script&lang=ts"
import style0 from "./PDFPaginator.vue?vue&type=style&index=0&id=3c8d5ee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports